import React from 'react';
import { useSearchParams } from 'react-router-dom';
import AvaliacaoForm from '../../components/Avaliacao/AvaliacaoForm';

const RegistrarAvaliacaoPage = () => {
    const [searchParams] = useSearchParams();
    const defesaId = searchParams.get('defesaId');

    return (
        <div>
            <h2>PARECER DO JÚRI SOBRE A DEFESA PÚBLICA</h2>
            <AvaliacaoForm 
                defesaId={defesaId}
                onSuccess={() => alert('Avaliação registrada com sucesso!')} 
            />
        </div>
    );
};

export default RegistrarAvaliacaoPage;